import { SketchObjectType } from '../sketch-object';
import { type LibItem } from './common';

export const dehumidifier: LibItem = {
  id: Math.random() * 100000,
  thumbUrl: '/assets/images/sketch-tool/dehumidifier.svg',
  name: 'Dehumidifier',
  type: SketchObjectType.Image,
  src: '/assets/images/sketch-tool/dehumidifier.svg',
  width: 48,
  height: 48,
};
